/**
 * 2019-04-09
 * handan
 * 背调记录数据
 */

import { ajax } from "../utils/http/http";
import handleError from "../utils/handleError";
import { result } from "./mock.js";
let isMock = false;
const getRecordData = async (params) => {
  let data = await ajax("/58/batch/checkList","POST",params)
  if( isMock ) data = result ;
  if(data.code==="1"){
    return Promise.resolve(data.data)
  }else{
    return handleError(data);
  }
}

const removeRecord = async (authid) => {
  let data = await ajax(`/58/batch/auth/${authid}`,"POST")
  if(data.code === "1"){
    return Promise.resolve(data.data);
  }else{
    return handleError(data)
  }
}

export {
  getRecordData,
  removeRecord,
};